<template>
  <div>
    <el-button
      style="margin-bottom: 10px"
      type="primary"
      icon="el-icon-circle-plus-outline"
      @click="openDialog()"
      >新增合服任务</el-button
    >

    <el-table
      :data="list"
      border
      :key="tableKey"
      size="small"
      style="width: 761px"
      v-el-table-infinite-scroll="loadMore"
      :infinite-scroll-disabled="list.length == 0"
    >
      <el-table-column
        prop="createdAt"
        label="创建时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{ $util.ms2datetime(scope.row.createdAt) }}
        </template>
      </el-table-column>
      <el-table-column
        label="合并范围"
        align="center"
        prop="zoneSet"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.zoneSet }}
        </template>
      </el-table-column>
      <el-table-column
        prop="newMasterZoneId"
        label="新主分区"
        align="center"
        width="120"
      >
      </el-table-column>
      <el-table-column
        label="状态"
        show-overflow-tooltip
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 0" style="color: rgb(177, 9, 9)"
            >未完成</span
          >
          <span v-if="scope.row.status == 1" style="color: rgb(187, 169, 7)"
            >完成待确认</span
          >
          <span v-if="scope.row.status == 2" style="color: green"
            >完成且确认</span
          >
        </template>
      </el-table-column>

      <el-table-column
        prop="finishedAt"
        label="完成时间"
        align="center"
        width="140"
      >
        <template slot-scope="scope">
          {{
            scope.row.finishedAt != "0"
              ? $util.ms2datetime(scope.row.finishedAt)
              : ""
          }}
        </template>
      </el-table-column>

      <el-table-column label="进度" align="center" width="120">
        <template slot-scope="scope">
          <span class="link-button" @click="openProcessDialog(scope.row)"
            >查看</span
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
  data() {
    return {
      list: [],
      intervalEntry: null,
      tableKey: true,
    };
  },

  async created() {
    await this.loadList(0, 10);
    this.intervalEntry = setTimeout(async () => {
      await this.refresh();
    }, 2000);
  },
  beforeDestroy() {
    clearInterval(this.intervalEntry);
  },

  methods: {
    async loadMore() {
      await this.loadList(this.list.length, 10);
    },
    async loadList(skip, limit) {
      if (skip == 0) {
        this.list = [];
        this.needToRefreshList = [];
      }

      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/queryZoneMergeTasks`,
            {
              skip: skip,
              limit: limit,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        let listInResponse = resData.data.list || [];

        this.list = this.list.concat(listInResponse);
      } catch (e) {}
    },

    async refresh() {
      let resfreshTable = false;
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].status == 2) {
          continue;
        }
        let status = this.list[i].status;
        this.list[i] = await this.refresh_callApi(this.list[i].id);

        if (this.list[i].status != status) {
          resfreshTable = true;
        }
      }

      if (resfreshTable) {
        this.tableKey = !this.tableKey;
      }
    },

    async refresh_callApi(id) {
      let entry = null;
      try {
        let resData = (
          await axios.post(
            `${this.$util.getBackendApiBase()}/v1/admin/queryZoneMergeTasks`,
            {
              id: id,
            },
            {
              headers: {
                token: this.$bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message({
            message: resData.message,
            type: "error",
          });
          return;
        }

        let listInResponse = resData.data.list || [];
        if (listInResponse.length > 0) {
          entry = listInResponse[0];
        }
      } catch (e) {}

      return entry;
    },

    async openDialog() {
      this.$dialogutil.open("MergeZonesDialog", {
        closedCallback: () => {
          this.loadList(0, 10);
        },
        data: {},
      });
    },

    async openProcessDialog(entry) {
      this.$dialogutil.open("MergeZonesProcessDialog", {
        closedCallback: () => {
          this.loadList(0, 10);
        },
        data: { entry },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
// /deep/ .el-table__row td {
//     padding: 3px 0;
// }

// /deep/ .el-table .cell {
//     line-height: 18px;
// }

.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}
</style>